import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchRedirectCodeURL } from "../../api/userApi";
import { Box, CircularProgress } from "@mui/material";

const CodeRedirect = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const path = location.pathname;
    const code = path.substring(3); // Remove the leading "/"

    if (code) {
      // We have a valid code, make API call
      handleCodeValidation(code);
    }
  }, [location]);

  const handleCodeValidation = async (code) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetchRedirectCodeURL(code);
      if (response?.success && response?.redirectUrl) {
        window.location.href = response?.redirectUrl; // Use window.location for external URLs
      } else {
        navigate("/register");
      }
    } catch (err) {
      setError("Failed to validate code");
      console.error("Error validating code:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <Box
          display={"flex"}
          justifyContent="center"
          alignItems={"center"}
          mt={3}
        >
          <CircularProgress />
        </Box>
      )}
      {error && <Box>Error: {error}</Box>}
    </div>
  );
};

export default CodeRedirect;
